import { TableCell } from "components/table_components/TableCellStyles";
import { parseDateValue } from "lib/columnSort";
import { toHumanRelativeDateFromNow } from "../../lib/utils/relative_time";

type Props = {
  date: string | null | undefined;
  minWidth: number;
};

export function RelativeDateCell({ date, minWidth }: Props) {
  if (!date) return <TableCell minWidth={minWidth}>-</TableCell>;

  const parsedDate = parseDateValue(date);
  return (
    <TableCell minWidth={minWidth}>
      {!parsedDate.isValid ? "-" : toHumanRelativeDateFromNow(parsedDate.toJSDate())}
    </TableCell>
  );
}
